<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-file-text-o mr-2" />Materai</h5>
            <hr />
            <b-row>
                <b-col md="4">
                    <b-form-group label="Status">
                        <b-form-select v-model="filter.isActive" :options="optIsActiveFilter" @change="getItems(1)" />
                    </b-form-group>
                </b-col>
                <b-col md="8" class="text-right">
                    <b-form-group label="Tambah">
                        <b-button variant="success" @click="openCreateModal">
                            <i class="fa fa-plus mr-2" />Materai Baru
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                responsive class="mb-3"
            >
                <template v-slot:empty>Tidak ada data Materai.</template>
                <template v-slot:cell(amount)="row">
                    Rp. {{ $helper.formatThousand(row.item.amount) }}
                </template>
                <template v-slot:cell(direction)="row">
                    <b-badge :variant="row.item.direction === 'plus' ? 'success' : 'danger'">
                        {{ row.item.direction === 'plus' ? 'Plus (+)' : 'Minus (-)' }}
                    </b-badge>
                </template>
                <template v-slot:cell(is_active)="row">
                    <b-badge :variant="row.item.is_active ? 'success' : 'secondary'">
                        {{ row.item.is_active ? 'Aktif' : 'Nonaktif' }}
                    </b-badge>
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="warning" class="mr-1" v-b-tooltip.hover title="Edit"
                        @click="openEditModal(row.item)">
                        <i class="fa fa-pencil" />
                    </b-button>
                    <b-button size="sm" variant="danger" v-b-tooltip.hover title="Hapus"
                        @click="confirmDelete(row.item)">
                        <i class="fa fa-trash" />
                    </b-button>
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="pageSizeOptions"
                @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>

        <b-modal id="m-create" title="Tambah Materai Baru" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Nama Materai" description="Contoh: Materai 10.000">
                <b-input v-model="input.name" maxlength="100" />
            </b-form-group>
            <b-form-group label="Nominal (Rp)" description="Nilai tetap dalam rupiah. Contoh: 10.000">
                <b-input-group prepend="Rp.">
                    <b-form-input v-model="input.amount" @input="sanitizeAmount('input')" />
                </b-input-group>
            </b-form-group>
            <b-form-group label="Plus / Minus">
                <b-form-select v-model="input.direction" :options="optDirection" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmCreate">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>

        <b-modal id="m-edit" title="Edit Materai" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Nama Materai">
                <b-input v-model="edit.name" maxlength="100" />
            </b-form-group>
            <b-form-group label="Nominal (Rp)">
                <b-input-group prepend="Rp.">
                    <b-form-input v-model="edit.amount" @input="sanitizeAmount('edit')" />
                </b-input-group>
            </b-form-group>
            <b-form-group label="Plus / Minus">
                <b-form-select v-model="edit.direction" :options="optDirection" />
            </b-form-group>
            <b-form-group label="Status">
                <b-form-select v-model="edit.isActive" :options="optIsActive" />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmEdit">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'list-materai',
    data() {
        return {
            initStatus: 0,
            isBusy: false,
            isSubmitting: false,

            filter: {
                isActive: ""
            },

            input: {
                name: "",
                amount: "",
                direction: "plus",
                isActive: true
            },

            edit: {
                id: null,
                name: "",
                amount: "",
                direction: "plus",
                isActive: true
            },

            items: [],
            totalRows: 0,
            currentPage: 1,
            perPage: 10,

            fields: [
                { key: "name", label: "Nama" },
                { key: "amount", label: "Nominal" },
                { key: "direction", label: "Plus / Minus" },
                { key: "is_active", label: "Status" },
                { key: "action", label: "Aksi" }
            ],

            optDirection: [
                { value: "plus", text: "Plus (+)" },
                { value: "minus", text: "Minus (-)" }
            ],

            optIsActive: [
                { value: true, text: "Aktif" },
                { value: false, text: "Nonaktif" }
            ],

            optIsActiveFilter: [
                { value: "", text: "Semua" },
                { value: "true", text: "Aktif" },
                { value: "false", text: "Nonaktif" }
            ],

            pageSizeOptions: [
                { value: 10, text: "10" },
                { value: 20, text: "20" },
                { value: 50, text: "50" }
            ]
        }
    },

    methods: {
        init() {
            this.initStatus = 0
            this.getItems(1).then(() => {
                this.initStatus = 1
            }).catch(() => {
                this.initStatus = -1
            })
        },

        getItems(page = 1) {
            this.isBusy = true
            this.currentPage = page

            const params = {
                page: this.currentPage,
                per_page: this.perPage
            }
            if (this.filter.isActive !== "") params.is_active = this.filter.isActive

            return this.$axios.get("stamp-duties", { params }).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
            }).catch(error => {
                this.$helper.parseError(this, error)
            }).finally(() => {
                this.isBusy = false
            })
        },

        openCreateModal() {
            this.input = { name: "", amount: "", direction: "plus", isActive: true }
            this.$bvModal.show("m-create")
        },

        confirmCreate() {
            if (this.$helper.isBlank(this.input.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }
            if (this.$helper.isBlank(this.input.amount) || Number(this.input.amount) < 0) {
                return this.$helper.toastError(this, "Nominal harus diisi dan tidak boleh negatif!")
            }

            const confirmed = confirm("Tambah Materai baru ini?")
            if (!confirmed) return

            this.isSubmitting = true
            this.$axios.post("stamp-duties", {
                name: this.input.name,
                amount: this.$helper.toNumber(this.input.amount),
                direction: this.input.direction
            }).then(() => {
                this.$helper.toastSuccess(this, "Materai berhasil ditambahkan!")
                this.$bvModal.hide("m-create")
                this.getItems(1)
            }).catch(error => {
                this.$helper.parseError(this, error)
            }).finally(() => {
                this.isSubmitting = false
            })
        },

        openEditModal(item) {
            this.edit = {
                id: item.id,
                name: item.name,
                amount: this.$helper.formatThousand(item.amount),
                direction: item.direction,
                isActive: !!item.is_active
            }
            this.$bvModal.show("m-edit")
        },

        confirmEdit() {
            if (this.$helper.isBlank(this.edit.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }
            if (this.$helper.isBlank(this.edit.amount) || Number(this.edit.amount) < 0) {
                return this.$helper.toastError(this, "Nominal harus diisi dan tidak boleh negatif!")
            }

            const confirmed = confirm("Simpan perubahan Materai ini?")
            if (!confirmed) return

            this.isSubmitting = true
            this.$axios.put("stamp-duties/" + this.edit.id, {
                name: this.edit.name,
                amount: this.$helper.toNumber(this.edit.amount),
                direction: this.edit.direction,
                is_active: this.edit.isActive
            }).then(() => {
                this.$helper.toastSuccess(this, "Materai berhasil diubah!")
                this.$bvModal.hide("m-edit")
                this.getItems(this.currentPage)
            }).catch(error => {
                this.$helper.parseError(this, error)
            }).finally(() => {
                this.isSubmitting = false
            })
        },

        confirmDelete(item) {
            const confirmed = confirm("Hapus Materai '" + item.name + "'? Tindakan ini tidak dapat dibatalkan.")
            if (!confirmed) return

            this.$axios.delete("stamp-duties/" + item.id).then(() => {
                this.$helper.toastSuccess(this, "Materai berhasil dihapus!")
                this.getItems(this.currentPage)
            }).catch(error => {
                this.$helper.parseError(this, error)
            })
        },

        sanitizeAmount(target) {
            const raw = String(this[target].amount).replace(/\./g, "")
            const cleaned = raw.replace(/[^0-9]/g, "")
            this[target].amount = cleaned.replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(1)
        },

        onPageChange(newPage) {
            this.getItems(newPage)
        }
    },

    created() {
        this.init()
    }
}
</script>
